<template>
  <b-row>
    <b-col cols="12">
      <b-form-group>
        <label
          for="excmnote_title"
          class="form-control-label">{{$t('views.excmnote.form.title')}}</label>
        <input
          id="excmnote_title"
          v-model="item.title"
          :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('title', $event.target.value)">
        <div
          v-if="isInvalid('title')"
          class="invalid-feedback">
          {{ violations.title }}
        </div>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="categoryOptions.length > 0">
      <b-form-group>
        <label
          for="excmrelation_idCategory"
          class="form-control-label">{{$t('views.exsbitems.list.category')}}:</label>
        <model-select :options="categoryOptions" v-model="item.idCategory"></model-select>
        <div
          v-if="isInvalid('idCategory')"
          class="invalid-feedback">{{ violations.idCategory }}</div>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group>
        <label
          for="excmnote_description"
          class="form-control-label">{{$t('views.excmnote.form.description')}}</label>
        <textarea
          id="excmnote_description"
          v-model="item.description"
          :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
          type="text"
          placeholder=""
          @input="handleUpdateField('description', $event.target.value)">
        </textarea>
        <div
          v-if="isInvalid('description')"
          class="invalid-feedback">
          {{ violations.description }}
        </div>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group>
        <label
          for="excmnote_idCase"
          class="form-control-label">{{$t('views.excmnote.form.idCase')}}
        </label>
        <BaseSelectInput
          ref="caseInput"
          v-model="item.idCase"
          :search-callback="caseSearchCallback"
          :display-values="['title', 'contractorUserData.fullName', 'contractorUserData.firmname1']"
          :query-param="'contractor'"
          :disabled="isCaseInputDisabled"
          :placeholder-autocomplete="'Zacznij wpisywać kontrahenta lub ID zlecenia'"
          :is-auto-complete-mode="isAutocompleteEnabledForCaseInput"
        ></BaseSelectInput>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <b-form-group>
        <label
          for="excmnote_idCase"
          class="form-control-label">{{$t('views.excmnote.form.idOrganizationLead')}}
        </label>
        <BaseSelectInput
          ref="caseInput"
          v-model="item.idOrganizationLead"
          :search-callback="organizationLeadSearchCallback"
          :display-values="['title']"
          :query-param="'title'"
          :disabled="isOrganizationLeadInputDisabled"
          :placeholder-autocomplete="'Zacznij wpisywać tytuł projektu sprzedażowego'"
          :is-auto-complete-mode="isAutocompleteEnabledForCaseInput"
        ></BaseSelectInput>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-if="!(idFirm && idCase)">
      <b-form-group>
        <b-form-checkbox v-model="isContractorNote">
          {{ $t('views.excmnote.form.contractorNote') }}
        </b-form-checkbox>
      </b-form-group>
    </b-col>
    <b-col cols="12" v-show="isContractorNote">
      <b-form-group>
        <label
          for="excmnote_idUserData"
          class="form-control-label">{{$t('views.excmcontractor.show.title')}}
        </label>
        <BaseSelectInput
          v-model="item.idUserData"
          :search-callback="userDataSearchCallback"
          :display-values="['fullName', 'firmname1']"
          :disabled="isUserDataInputDisabled"
          :query-param="'userdata'"
          :is-auto-complete-mode="isAutocompleteEnabledForUserDataInput"
        ></BaseSelectInput>
      </b-form-group>
    </b-col>
    <b-col cols="12">
      <button
        type="submit"
        class="btn btn-success"
        @click="handleSubmit()"
      >{{$t('buttons.submit')}}</button>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions } from 'vuex'
import ApiService from '@/utils/ApiService'
import BaseSelectInput from '@/components/BaseComponents/BaseSelectInput'
import getId from '@/utils/getIdFromLink'
import { getUserRoles } from '@/utils/checkRoles'
import { ModelSelect } from 'vue-search-select'

export default {
  components: { BaseSelectInput, ModelSelect },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },
    values: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => {}
    },
    initialValues: {
      type: Object,
      default: () => {}
    },
    idCase: {
      type: String,
      required: false
    },
    idFirm: {
      type: String,
      required: false
    },
    idOrganizationLead: {
      type: String,
      required: false
    }
  },
  watch: {
    isContractorNote (val) {
      if (val && this.item.idOrganizationLead && !this.idFirm) {
        this.organizationLeadSelectedHandler()
      }
    },
    'item.idUserData' (val) {
      if (!this.isAutocompleteEnabledForCaseInput && val) {
        this.$refs.caseInput.initialValueHandler()
      }
    },
    'item.idCase' (val) {
      if (val && !this.idFirm) {
        this.caseSelectedHandler()
      }
    },
    'item.idOrganizationLead' (val) {
      if (val && !this.idFirm) {
        this.organizationLeadSelectedHandler()
      }
    }
  },
  mounted () {
    if (this.idFirm && !this.idCase) {
      this.isContractorNote = true
    }
  },
  computed: {
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    isSalesRepresentative () {
      return getUserRoles().roles.includes('ROLE_SALES_REPRESENTATIVE')
    },
    isAutocompleteEnabledForCaseInput () {
      return (this.$store.getters['configuration/enableAutoCompleteForUserData'] && !this.isUserDataInputDisabled) && !this.isContractorNote
    },
    isAutocompleteEnabledForUserDataInput () {
      return this.$store.getters['configuration/enableAutoCompleteForUserData'] && !this.isCaseInputDisabled
    },
    isCaseInputDisabled () {
      return (!!this.idCase)
    },
    isUserDataInputDisabled () {
      return !!this.idFirm
    },
    isOrganizationLeadInputDisabled () {
      return !!this.idOrganizationLead
    },
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },
    violations () {
      return this.errors || {}
    }
  },
  data () {
    return {
      isContractorNote: false,
      emptyOption: {
        value: null,
        label: this.$t('views.excmnote.form.empty')
      },
      categoryOptions: []
    }
  },
  created () {
    this.fetchCategories()
  },
  methods: {
    async caseSelectedHandler () {
      const response = await new ApiService(this.item.idCase).getResults()
      this.item.idUserData = response.contractorUserData['@id']
    },
    async organizationLeadSelectedHandler () {
      const response = await new ApiService(this.item.idOrganizationLead).getResults()
      if (response.idUserData) {
        this.item.idUserData = response.idUserData['@id']
      }
    },
    async caseSearchCallback (params = {}) {
      let baseParams = {
        pagination: false,
        contractorUserData: this.idFirm ? getId(this.idFirm) : getId(this.item.idUserData),
        disableRolesFiltering: (this.isSalesRepresentative || this.isWholesaler || getUserRoles().default_disable_roles_filtering) ? 1 : 0
      }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_c_m_cases', baseParams).getResults()
      return response.items
    },
    async userDataSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('user_datas/list', baseParams).getResults()
      return response.items
    },
    async organizationLeadSearchCallback (params = {}) {
      let baseParams = { pagination: false }
      Object.assign(baseParams, params)
      const response = await new ApiService('e_x_a_b_organization_leads', baseParams).getResults()
      return response.items
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    },
    async fetchCategories () {
      let params = { pagination: false }
      this.categoryOptions = []
      const response = await new ApiService('e_x_c_m_relation_categories', params).getResults()
      this.categoryOptions = response.items.map(entry => {
        return {
          value: entry['@id'],
          text: entry.title
        }
      })
      if (!this.item['@id'] && this.categoryOptions.length > 0) {
        this.item.idCategory = this.categoryOptions[0].value
      }
    },
    ...mapActions({
      getUserDataOptionsFromStore: 'userdata/list/default'
    })
  }
}
</script>
